import { InjectionToken } from "@angular/core";

export const SELECT_CLASSES: InjectionToken<SelectClasses> = new InjectionToken<
  SelectClasses
>("SELECT_CLASSES");

export interface SelectClasses {
  parent: string;
  parentTouched: string;
  parentFull: string;
  parentActive: string;
  parentDisabled: string;
  label: string;
  value: string;
  scrollContainer: string;
  selection: string;
  clearable: string;
  clearButton: string;
  optionsList: string;
  optionsListAvailable: string;
  optionsListSelected: string;
  header: string;
  loadingNotice: string;
  optionsListReversed: string;
  option: string;
  optionFocused: string;
  optionSelected: string;
  search: string;
  controls: string;
}

export function getSelectClasses(parentSelector: string): SelectClasses {
  return {
    parent: parentSelector,
    parentFull: `${parentSelector}--full`,
    parentTouched: `${parentSelector}--touched`,
    parentActive: `${parentSelector}--active`,
    parentDisabled: `${parentSelector}--disabled`,
    label: `${parentSelector}__label`,
    value: `${parentSelector}__value`,
    selection: `${parentSelector}__selection`,
    header: `${parentSelector}__header`,
    search: `${parentSelector}__search`,
    controls: `${parentSelector}__controls`,
    scrollContainer: `${parentSelector}__scroll-container`,
    clearable: `${parentSelector}__selection--has-clear`,
    clearButton: `${parentSelector}__clear`,
    optionsList: `${parentSelector}__options-list`,
    optionsListAvailable: `${parentSelector}__options-list--available`,
    optionsListSelected: `${parentSelector}__options-list--selected`,
    optionsListReversed: `${parentSelector}__options-list--reversed`,
    option: `${parentSelector}__option`,
    optionFocused: `${parentSelector}__option--focused`,
    optionSelected: `${parentSelector}__option--selected`,
    loadingNotice: `${parentSelector}__loading-notice`
  };
}
